// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1xAf8","row":"styles_row__2IRuR"};